<script setup lang="ts">
import { computed } from 'vue';

const VALID_UNIT = /(\d+(?:\.\d+)?)(lb|oz)/;

const props = defineProps<{ bagSize: string; unitName: string }>();

const type = computed(() => (props.bagSize.includes('Container') ? 'Container' : 'Bag'));
const unit = computed(() => props.unitName.match(VALID_UNIT));
</script>

<template>
  <div v-if="unit" class="bg-nuts-sky-950 rounded-[100%] p-2">
    <span class="flex flex-col justify-center items-center aspect-square">
      <span>
        <span class="text-4xl font-bold text-white capitalize font-sofia-pro">
          {{ unit[1] }}
        </span>
        <span class="text-2xl text-white font-sofia-pro">
          {{ unit[2] }}
        </span>
      </span>
      <span class="w-24 text-lg font-semibold text-center text-white capitalize font-sofia-pro">
        {{ type }}
      </span>
    </span>
  </div>
</template>
